const {
  getContentValue,
  setValue
} = require('@truqc/content-path');
const {
  mergeDeepRight
} = require('ramda');
const {
  isPlainObject
} = require('lodash');
const formatPaths = require('./formatPaths');
const {
  generateMergePatch
} = require('./mergePatch');
const clone = json => JSON.parse(JSON.stringify(json));

// find all paths matching `value` in the object
const findPathsWithValue = (obj, value, parentPath = []) => {
  // for each key in obj (obj is either an object or an array)
  if (!isPlainObject(obj)) {
    return [];
  }
  let result = [];
  const keys = Object.keys(obj);
  keys.forEach(key => {
    const newPath = JSON.parse(JSON.stringify(parentPath));
    newPath.push(key);
    // if the current property (value of obj[key]) is also an object/array
    if (isPlainObject(obj[key])) {
      // try finding value in that object
      result = result.concat(findPathsWithValue(obj[key], value, newPath, result));
    } else if (value === undefined || obj[key] === value) {
      // otherwise (if obj[key] is not an object or
      // array) we check if it is the value we're looking for
      // if it is then we return the path array (this is where the path array get constructed)
      result.push(newPath);
    }
  });
  return result;
};
const setPatchContentAtPath = (patch, path, contentAtPath) => {
  const patchContent = getContentValue(path, patch);
  let newValueContent = contentAtPath;
  if (patchContent !== undefined) {
    // then we want to create a merge of content and the
    // mergePatch value at this path.
    newValueContent = mergeDeepRight(contentAtPath, patchContent);
  }
  const newPatchContent = setValue(path, patch, newValueContent);
  return newPatchContent;
};

// checks for all single picker instances on formatInput and
// add _atomic to incoming patches related to those content paths.
const createAtomicPatch = (formatInput, patch) => {
  let result = {};
  const criteria = [{
    type: 'optionPickerField',
    allowsMultipleSelection: undefined,
    contentPath: 'isDefined'
  }, {
    type: 'optionPickerField',
    allowsMultipleSelection: false,
    contentPath: 'isDefined'
  }, {
    type: 'singlePickerField',
    contentPath: 'isDefined'
  }, {
    type: 'optionPickerButton',
    contentPath: 'isDefined'
  }, {
    type: 'singlePickerButton',
    contentPath: 'isDefined'
  }, {
    type: 'formSearchField',
    allowsMultipleSelection: undefined,
    contentPath: 'isDefined'
  }, {
    type: 'formSearchField',
    allowsMultipleSelection: false,
    contentPath: 'isDefined'
  }, {
    type: 'optionSearchField',
    allowsMultipleSelection: undefined,
    contentPath: 'isDefined'
  }, {
    type: 'optionSearchField',
    allowsMultipleSelection: false,
    contentPath: 'isDefined'
  }];
  // find optionPickerFields that are single picker with implicit
  result = formatPaths.nullPatchFromCriteria(result, patch, formatInput, criteria);
  return result;
};

// we need to go to each node in the preMergePatch tree
// and send the entire content from that node down
// in the original content.  From those nodes down,
// we are expecting atomic data, not a diff between
// what is currently on the server and what we have.
const setAtomicValues = (patchIn, preMergePatch, content) => {
  let patch = clone(patchIn);
  const paths = findPathsWithValue(preMergePatch, null);
  paths.forEach(pathArray => {
    const path = pathArray.join('/');
    const contentAtPath = getContentValue(path, content);
    // null is valid content
    if (contentAtPath !== undefined) {
      patch = setPatchContentAtPath(patch, path, contentAtPath);
    }
  });
  return patch;
};
const generateMergePatchesWithAtomicValues = (formatInput, originalContent, currentContent) => {
  // make sure to include entire content values where there are mergePatches.
  let mergePatch = generateMergePatch(originalContent, currentContent);
  if (mergePatch === undefined) {
    return undefined;
  }
  const preMergePatch = createAtomicPatch(formatInput, mergePatch);
  mergePatch = setAtomicValues(mergePatch, preMergePatch, currentContent);
  return [preMergePatch, mergePatch];
};
module.exports = {
  createAtomicPatch,
  generateMergePatchesWithAtomicValues,
  setAtomicValues
};